var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_vm._v("浙ICP备**********号-1 / 京公网安备************号 / Powered by 2020 jingning")])}
var staticRenderFns = []

export { render, staticRenderFns }